module.exports = __webpack_public_path__ + "img/图1-34水平线和竖直线的运笔方向及徒手画法.2a27065e.png";